module.exports = __webpack_public_path__ + "img/icon-address.1e6beced.png";